import { render, staticRenderFns } from "./CardRequest.vue?vue&type=template&id=f0a53072&scoped=true&"
import script from "./CardRequest.vue?vue&type=script&lang=js&"
export * from "./CardRequest.vue?vue&type=script&lang=js&"
import style0 from "./CardRequest.vue?vue&type=style&index=0&id=f0a53072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a53072",
  null
  
)

export default component.exports